module.exports = __webpack_public_path__ + "img/avatar-80.7a6182a5.png";